/**
 *获得环境变量
 */
export function getENV() {
  let host = url('hostname')
  return appConfig.env[host] ? appConfig.env[host] : appConfig.env['localhost']
}

/**
 * 时间日期格式化
 * @param time
 * @param str
 * @returns {*}
 */
export const timeFormat = (time, str) => {
  if (!time) return "";
  const handlerZero = (value) => {
    return value < 10 ? '0' + value : value;
  };
  const dateObj = new Date(time);
  const Y = dateObj.getFullYear();
  const m = handlerZero(dateObj.getMonth() + 1);
  const d = handlerZero(dateObj.getDate());
  const W = dateObj.getDay();
  const H = handlerZero(dateObj.getHours());
  const M = handlerZero(dateObj.getMinutes());
  const S = handlerZero(dateObj.getSeconds());

  const ruleArr = [
    {regx: new RegExp('%' + 'Y', 'g'), value: Y},
    {regx: new RegExp('%' + 'm', 'g'), value: m},
    {regx: new RegExp('%' + 'd', 'g'), value: d},
    {regx: new RegExp('%' + 'H', 'g'), value: H},
    {regx: new RegExp('%' + 'M', 'g'), value: M},
    {regx: new RegExp('%' + 'S', 'g'), value: S},
    {regx: new RegExp('%' + 'W', 'g'), value: ['日', '一', '二', '三', '四', '五', '六'][W]}
  ];

  ruleArr.forEach(r => {
    str = str.replace(r.regx, r.value);
  });

  return str;
};

/**
 * 获得js数据类型
 * @param data
 * @returns {string}
 */
export function getJsDataType(data) {
  let type = Object.prototype.toString.call(data);
  type = type.toLowerCase();
  return type.replace(/\[object\s|\]/g, '');
}

/**
 * 空值判断
 * @param data
 * @returns {boolean}
 */
export function isEmpty(data) {
  const type = getJsDataType(data);
  let ret;
  switch (type) {
    case 'number':
      ret = data === 0;
      break;
    case 'array':
      ret = data.length === 0;
      break;
    case 'object':
      ret = Object.keys(data).length === 0;
      break;
    case 'string':
      data = data.replace(/\s/g, '');
      if (data === 'null' || data === 'undefined' || data === '0') ret = true;
      else ret = data.length === 0;
      break;
    case 'null':
    case 'undefined':
      ret = true;
      break;
    default:
      ret = false;
  }

  return ret;
}

/**
 * 两位小数计算
 * @param r
 */
export function formatFloat(r) {
  r = parseFloat(r);
  r = r.toFixed(2);
  return parseFloat(r);
}
